export const AdminLoginAPI = "https://catalogmaker.in/API/UserLogIn.php";
